import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type AddProductionMaterialEventToJobMutationVariables = Types.Exact<{
  input: Types.AddProductionMaterialEventToJobDataInput;
}>;


export type AddProductionMaterialEventToJobMutation = { __typename?: 'Mutation', addProductionMaterialEventToJob: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', productionLotId: string, status: Types.ProductionLotStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveProductionMaterialEventFromJobMutationVariables = Types.Exact<{
  input: Types.RemoveProductionMaterialEventFromJobDataInput;
}>;


export type RemoveProductionMaterialEventFromJobMutation = { __typename?: 'Mutation', removeProductionMaterialEventFromJob: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', productionLotId: string, status: Types.ProductionLotStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AddProductionSpaceEventToJobMutationVariables = Types.Exact<{
  input: Types.AddProductionSpaceEventToJobDataInput;
}>;


export type AddProductionSpaceEventToJobMutation = { __typename?: 'Mutation', addProductionSpaceEventToJob: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', productionLotId: string, status: Types.ProductionLotStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RemoveProductionSpaceEventFromJobMutationVariables = Types.Exact<{
  input: Types.RemoveProductionSpaceEventFromJobDataInput;
}>;


export type RemoveProductionSpaceEventFromJobMutation = { __typename?: 'Mutation', removeProductionSpaceEventFromJob: { __typename?: 'ProductionLotPayload', productionLot?: { __typename?: 'ProductionLotStateData', productionLotId: string, status: Types.ProductionLotStatus } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const AddProductionMaterialEventToJobDocument = new TypedDocumentString(`
    mutation AddProductionMaterialEventToJob($input: AddProductionMaterialEventToJobDataInput!) {
  addProductionMaterialEventToJob(input: $input) {
    productionLot {
      ...ProductionLotEventAttachmentState
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotEventAttachmentState on ProductionLotStateData {
  productionLotId
  status
}`);
export const RemoveProductionMaterialEventFromJobDocument = new TypedDocumentString(`
    mutation RemoveProductionMaterialEventFromJob($input: RemoveProductionMaterialEventFromJobDataInput!) {
  removeProductionMaterialEventFromJob(input: $input) {
    productionLot {
      ...ProductionLotEventAttachmentState
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotEventAttachmentState on ProductionLotStateData {
  productionLotId
  status
}`);
export const AddProductionSpaceEventToJobDocument = new TypedDocumentString(`
    mutation AddProductionSpaceEventToJob($input: AddProductionSpaceEventToJobDataInput!) {
  addProductionSpaceEventToJob(input: $input) {
    productionLot {
      ...ProductionLotEventAttachmentState
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotEventAttachmentState on ProductionLotStateData {
  productionLotId
  status
}`);
export const RemoveProductionSpaceEventFromJobDocument = new TypedDocumentString(`
    mutation RemoveProductionSpaceEventFromJob($input: RemoveProductionSpaceEventFromJobDataInput!) {
  removeProductionSpaceEventFromJob(input: $input) {
    productionLot {
      ...ProductionLotEventAttachmentState
    }
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotEventAttachmentState on ProductionLotStateData {
  productionLotId
  status
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    AddProductionMaterialEventToJob: build.mutation<AddProductionMaterialEventToJobMutation, AddProductionMaterialEventToJobMutationVariables>({
      query: (variables) => ({ document: AddProductionMaterialEventToJobDocument, variables })
    }),
    RemoveProductionMaterialEventFromJob: build.mutation<RemoveProductionMaterialEventFromJobMutation, RemoveProductionMaterialEventFromJobMutationVariables>({
      query: (variables) => ({ document: RemoveProductionMaterialEventFromJobDocument, variables })
    }),
    AddProductionSpaceEventToJob: build.mutation<AddProductionSpaceEventToJobMutation, AddProductionSpaceEventToJobMutationVariables>({
      query: (variables) => ({ document: AddProductionSpaceEventToJobDocument, variables })
    }),
    RemoveProductionSpaceEventFromJob: build.mutation<RemoveProductionSpaceEventFromJobMutation, RemoveProductionSpaceEventFromJobMutationVariables>({
      query: (variables) => ({ document: RemoveProductionSpaceEventFromJobDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useAddProductionMaterialEventToJobMutation, useRemoveProductionMaterialEventFromJobMutation, useAddProductionSpaceEventToJobMutation, useRemoveProductionSpaceEventFromJobMutation } = injectedRtkApi;
